<template>
<div class="chapter">
<div class="inner_page">
<p><a id="toc"></a></p>
<div class="fmh1">Table of Contents</div>
<div> <br/></div>
<div class="cfmh"><a href="#/jenn_9781558616912_oeb_fm1_r1">OTHER BOOKS IN THE REUBEN/RIFKIN SERIES</a></div>
<div class="cfmh"><a href="#/jenn_9781558616912_oeb_tp_r1">Title Page</a></div>
<div class="cfmh"><a href="#/jenn_9781558616912_oeb_ded_r1">Dedication</a></div>
<div class="cfmh"><a href="#/jenn_9781558616912_oeb_fm3_r1">Prologue</a></div>
<div> <br/></div>
<div class="cct"><a href="#/jenn_9781558616912_oeb_c01_r1">California, July 2000</a></div>
<div class="cct"><a href="#/jenn_9781558616912_oeb_c02_r1">California, August 2000</a></div>
<div class="cct"><span href="#/jenn_9781558616912_oeb_c03_r1" title="Link target outside of Sample">California, September 2000</span></div>
<div class="cct"><span href="#/jenn_9781558616912_oeb_c04_r1" title="Link target outside of Sample">California, October 2000</span></div>
<div class="cct"><span href="#/jenn_9781558616912_oeb_c05_r1" title="Link target outside of Sample">California, October 2000</span></div>
<div class="cct"><span href="#/jenn_9781558616912_oeb_c06_r1" title="Link target outside of Sample">California, November 2000</span></div>
<div class="cct"><span href="#/jenn_9781558616912_oeb_c07_r1" title="Link target outside of Sample">California, November 2000</span></div>
<div class="cct"><span href="#/jenn_9781558616912_oeb_c08_r1" title="Link target outside of Sample">Massachusetts, May 2001</span></div>
<div class="cct"><span href="#/jenn_9781558616912_oeb_c09_r1" title="Link target outside of Sample">Massachusetts, December 2002</span></div>
<div class="cct"><span href="#/jenn_9781558616912_oeb_c10_r1" title="Link target outside of Sample">Massachusetts, September 2003</span></div>
<div class="cct"><span href="#/jenn_9781558616912_oeb_c11_r1" title="Link target outside of Sample">Massachusetts, October 2003</span></div>
<div class="cct"><span href="#/jenn_9781558616912_oeb_c12_r1" title="Link target outside of Sample">Massachusetts, March 2004</span></div>
<div class="cct"><span href="#/jenn_9781558616912_oeb_c13_r1" title="Link target outside of Sample">Massachusetts, August 2004</span></div>
<div class="cct"><span href="#/jenn_9781558616912_oeb_c14_r1" title="Link target outside of Sample">Massachusetts, September 2004</span></div>
<div class="cct"><span href="#/jenn_9781558616912_oeb_c15_r1" title="Link target outside of Sample">Massachusetts, February 2005</span></div>
<div class="cct"><span href="#/jenn_9781558616912_oeb_c16_r1" title="Link target outside of Sample">Massachusetts, April 2005</span></div>
<div class="cct"><span href="#/jenn_9781558616912_oeb_c17_r1" title="Link target outside of Sample">Massachusetts, December 2006</span></div>
<div class="cct"><span href="#/jenn_9781558616912_oeb_c18_r1" title="Link target outside of Sample">Massachusetts, August 2007</span></div>
<div class="cct"><span href="#/jenn_9781558616912_oeb_c19_r1" title="Link target outside of Sample">Massachusetts, September 2007</span></div>
<div> <br/></div>
<div class="cbmh"><span href="#/jenn_9781558616912_oeb_ack_r1" title="Link target outside of Sample">Acknowledgements</span></div>
<div class="cbmh"><span href="#/jenn_9781558616912_oeb_cop_r1" title="Link target outside of Sample">Copyright Page</span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// jenn_9781558616912_oeb_toc_r1.vue?79d1e94b